module.exports = __webpack_public_path__ + "static/img/beizhi.3484e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/beizhi.png
// module id = WXgg
// module chunks = 1